var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n        opacity: .3;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-3 {\n        fill: #004a24;\n      }\n\n      .cls-4 {\n        fill: #e6e6e6;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 56.61,
    y1: 70.22,
    x2: 190.46,
    y2: 156.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 36.88,
    y: 38.64,
    width: 114.24,
    height: 112.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#306605",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 180,
    height: 180
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 90,
    cy: 90,
    r: 82.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.81,97.12l-26.77-21.2c-1.94-1.54-3.07-3.87-3.07-6.35v-18.65l6.02-4.36,66.95-2.55c.32-.01.63.01.94.08l22.35,4.67c2.19.46,4.23,1.48,5.91,2.96l29.43,19.82c1.63,6.48,2.07,14.77,2.07,18.59,0,35.37-22.22,65.54-53.45,77.33l-66.88-26.75c-.83-.33-1.51-.97-1.9-1.78l-4.42-9.21c-2.12-4.42-1.16-9.7,2.38-13.08l20.45-19.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.28,131.52H53.54c-2.71,0-4.52-1.59-5.45-4.76-.98-3.13-.36-5.41,1.89-6.86,17.67-11.76,44.13-28.64,79.34-50.66,1.9-1.18,3.53-2.46,4.92-3.86.23.4.41.86.57,1.38.67,2.14.24,3.7-1.29,4.69-12.1,8.04-30.19,19.59-54.29,34.66-2.71,1.69-4.66,3.69-5.84,5.98-1.15,2.27-1.39,4.57-.71,6.9.6,2.11,1.85,3.85,3.73,5.22,1.92,1.37,4.03,2.06,6.32,2.06h50.79c1.5,0,2.92-.49,4.26-1.48,1.34-.99,2.28-2.24,2.82-3.74.58-1.63.59-3.24.05-4.84-.51-1.62-1.52-3.05-3.01-4.25-6.03-4.95-12.99-10.44-20.88-16.47l-.05-.04c-2.03-1.57-1.89-4.68.27-6.06,6.24-3.99,12.85-8.31,19.83-12.96,1.79-1.21,3.02-2.85,3.69-4.93.67-2.04.67-4.2,0-6.47-.33-1.13-.8-2.16-1.4-3.06-.69-1.04-.77-2.35-.37-3.54.9-2.64.96-5.32.18-8.03-.88-3.07-2.7-5.62-5.45-7.63-2.8-2-5.88-3.01-9.24-3.01H49.97c-2.2,0-4.27.72-6.23,2.17-1.95,1.44-3.33,3.27-4.12,5.45-.84,2.38-.86,4.73-.07,7.07.75,2.38,2.22,4.46,4.41,6.23,8.82,7.23,18.99,15.25,30.51,24.07.02.02.05.04.07.05,2.97,2.3,2.77,6.84-.39,8.86-9.12,5.83-18.79,12.14-29,18.93-2.61,1.77-4.41,4.17-5.39,7.2-.98,2.98-.98,6.13,0,9.45.98,3.31,2.73,5.95,5.25,7.9,2.52,2.01,5.36,3.01,8.53,3.01h82.74c1.21,0,2.24-.42,3.08-1.26s1.26-1.86,1.26-3.08-.42-2.24-1.26-3.08c-.84-.83-1.87-1.26-3.08-1.26ZM52.68,53.73c-1.45-1.22-1.97-2.39-1.58-3.48.43-1.18,1.11-1.77,2.04-1.77h69.72c1.36,0,2.6.39,3.75,1.18,1.13.79,1.88,1.75,2.22,2.89.83,2.89-1,5.74-5.52,8.54-13.28,8.29-23.29,14.55-30.04,18.79-2.4,1.51-5.49,1.36-7.74-.37-14.85-11.4-25.81-19.99-32.84-25.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app_icon.06d78570050d145fd4d5cacac0c2679e.svg";
export { ForwardRef as ReactComponent };